import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const ProtectedRoute = ({ children, managerOnly = false, teamLeaderAndAbove = false }) => {
  const { isAuthenticated, isLoading, isManager, isTeamLeaderOrAbove } = useAuth();
  const location = useLocation();

  // 1. Session verification in progress (prevents premature redirection / race conditions on F5)
  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50/80 backdrop-blur-sm p-4">
        <div className="flex flex-col items-center max-w-sm w-full bg-white p-8 rounded-2xl shadow-lg border border-gray-100 animate-in fade-in duration-300">
          <div className="relative flex items-center justify-center w-16 h-16 mb-4">
            <div className="absolute inset-0 rounded-full border-4 border-indigo-100"></div>
            <div className="w-16 h-16 rounded-full border-4 border-transparent border-t-indigo-600 border-r-indigo-600 animate-spin"></div>
            <img 
              src="/logo.png" 
              alt="PlannMe Logo" 
              className="w-8 h-8 rounded-full absolute"
            />
          </div>
          <h3 className="text-lg font-bold text-gray-800 tracking-tight">Vérification de session...</h3>
          <p className="text-xs text-gray-500 mt-1 text-center">Connexion sécurisée en cours, veuillez patienter.</p>
        </div>
      </div>
    );
  }

  // 2. Not authenticated: redirect to login preserving the target location for deep linking
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 3. Manager permission check
  if (managerOnly && !isManager) {
    return <Navigate to="/gestionShifts" replace />;
  }

  // 4. Team Leader & Manager permission check
  if (teamLeaderAndAbove && !isTeamLeaderOrAbove) {
    return <Navigate to="/gestionShifts" replace />;
  }

  // 5. Authorized access
  return children;
};

export default ProtectedRoute;
